import React from 'react'
import { DI } from 'modules'
import { Link } from 'components/link'
import Component from 'components/component'

import { offset } from 'helpers/elements'

export class Panel extends Component {
  componentDidMount() {
    if (typeof this.props.onChangeFixed === 'function') {
      this.checkFixed()

      document.addEventListener('resize', this.checkFixed)
      document.addEventListener('scroll', this.checkFixed)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('resize', this.checkFixed)
    document.removeEventListener('scroll', this.checkFixed)
  }

  checkFixed = () => {
    if (
      parseInt(window.pageYOffset || document.documentElement.scrollTop, 0) +
        parseInt(window.innerHeight, 0) >
      parseInt(offset(this.panel).top, 0) + 45
    ) {
      this.props.onChangeFixed(false)
    } else {
      this.props.onChangeFixed(true)
    }
  }

  render() {
    const { strings } = this.props.common
    return (
      <div
        className="enterprise-send-request j-enterprise-panel"
        ref={el => (this.panel = el)}
      >
        <div className="enterprise-send-request__buttons">
          <div className="enterprise-send-request__cancel">
            <Link to="/plans">
              {strings['page.request_enterprise.form.cancel']}
            </Link>
          </div>
          <button
            tabIndex="32"
            type="submit"
            className="button"
            disabled={this.props.user.agreementRequest.pending}
            onClick={this.props.onClickSubmit}
          >
            {strings['page.request_enterprise.form.send']}
          </button>
          <div className="enterprise-send-request__text">
            {strings['page.request_enterprise.form.all_required']}
          </div>
        </div>
        <div className="enterprise-send-request__continue">
          <Link to="/">{strings['page.request_enterprise.form.continue']}</Link>
        </div>
      </div>
    )
  }
}

export default DI(['user'])(Panel)
